/* eslint-disable react/prop-types */
import styled from 'styled-components';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

function Spinner({ className = '' }) {
  return (
    <div className={className}>
      <Spin indicator={antIcon} />
    </div>
  );
}

/** @deprecated Используй Spinner из ui-kit */
export default styled(Spinner)`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;
